import WeaveJupyterPreview from '@wandb/weave/common/components/JupyterViewer';
import React from 'react';

import type {FileBrowserFile, UseFileBrowserLoadFile} from '../types';

type JupyterPreviewProps = {
  file: FileBrowserFile;
  useLoadFile: UseFileBrowserLoadFile;
};
export function JupyterPreview({file, useLoadFile}: JupyterPreviewProps) {
  return (
    <div className="p-16 border-wb-border rounded-lg border">
      <WeaveJupyterPreview useLoadFile={useLoadFile} file={file} />
    </div>
  );
}
